import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function applyBrand(color) {
  if (!color) return;
  document.documentElement.style.setProperty("--brand", color);
}

export const BRAND_DEFAULT = "#003366";

export function fileUrl(path) {
  return path ? `${process.env.REACT_APP_BACKEND_URL}/api/files/${path}` : null;
}

export default api;
